<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>

  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <mat-list *ngIf="!!boundGroup">
      <mat-list-item *ngFor="let key of objectKeys(boundGroup)"><span class="label">{{key}}</span><span [innerHTML]=boundGroup[key]></span>
      </mat-list-item>
    </mat-list>
  </mat-card>
</page-content>
